import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { Operator } from './operator.interface';

export class OperatorService {
   async getOperators() {
      const response = await http.get<Array<Operator>>('/operators', cacheFirstConfig);
      return response.data;
   }
}
